import { object, string } from "superstruct";

export const ShareWishlistsResultSchema = object({
    shareWishlistsUrl: string(),
});
